// dependencies
import React from "react";
import { Map } from "immutable";
import PropTypes from "prop-types";
import { connect } from "react-redux";

// components
import Spinner from "Components/Spinner";

// actions
import { checkEnvironmentBranches } from "../../actions";

// selectors
import { getIsRequesting } from "Selectors/app";
import { getEnvironmentBranch } from "../../selectors";

// styles
import css from "./BranchCheck";

class BranchCheck extends React.Component {
	static propTypes = {
		checkBranches: PropTypes.func.isRequired,
		isRequestingBranch: PropTypes.bool.isRequired,
		logan: PropTypes.instanceOf(Map).isRequired,
		demo: PropTypes.instanceOf(Map).isRequired,
		sandbox: PropTypes.instanceOf(Map).isRequired,
		production: PropTypes.instanceOf(Map).isRequired,
	};

	static defaultProps = {};

	componentDidMount = () => {
		this.props.checkBranches();
	};

	render = () => {
		const { isRequestingBranch } = this.props;

		const environments = [
			{ name: "Demo", location: "https://github.com/PerformYard/PerformYard", prop: this.props.demo },
			{ name: "Sandbox", location: "https://github.com/PerformYard/PerformYard", prop: this.props.sandbox },
			{ name: "Production", location: "https://github.com/PerformYard/PerformYard", prop: this.props.production },
			{ name: "Logan", location: "https://wolverine.talent.performyard.com/health", prop: this.props.logan },
		];

		return (
			<div className={css.BranchCheck}>
				{environments.map((environment) => (
					<div key={environment.name} className={css.environmentContainer}>
						<div className={css.environmentName}>{environment.name}</div>
						{isRequestingBranch ? (
							<Spinner size={18} />
						) : (
							<div className={css.environmentInfo}>
								<a
									className={css.environmentBranch}
									target="_blank"
									rel="noopener noreferrer"
									href={`${environment.location}/commits/${environment.prop.get("branch")}`}
								>
									{environment.prop.get("branch")}
								</a>
								<a
									className={css.environmentHash}
									target="_blank"
									rel="noopener noreferrer"
									href={`${environment.location}/commit/${environment.prop.get("hash")}`}
								>
									({environment.prop.get("hash").slice(0, 7)})
								</a>
							</div>
						)}
					</div>
				))}
			</div>
		);
	};
}

const mapStateToProps = (state) => ({
	logan: getEnvironmentBranch(state, "logan"),
	demo: getEnvironmentBranch(state, "demo"),
	sandbox: getEnvironmentBranch(state, "sandbox"),
	production: getEnvironmentBranch(state, "production"),
	isRequestingBranch: getIsRequesting(state, "APP:BRANCHCHECK"),
});

const mapDispatchToProps = (dispatch) => ({
	checkBranches: () => dispatch(checkEnvironmentBranches()),
});

export default connect(mapStateToProps, mapDispatchToProps)(BranchCheck);
